<script>
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDesktop,
  faUsers,
  faBuilding,
  faFileInvoice,
  faMoneyBillAlt,
  faHandHoldingUsd,
  faUserPlus,
  faCogs,
  faThLarge,
  faPlusCircle,
  faPaintBrush,
  faArrowCircleLeft,
  faPiggyBank,
  faIdCard,
  faGraduationCap,
  faEnvelopeOpenText,
  faUserTie,
  faQuestion,
  faHashtag,
} from '@fortawesome/free-solid-svg-icons';

import {
  faAddressBook,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faDesktop, faUsers, faBuilding, faFileInvoice, faMoneyBillAlt, faHandHoldingUsd, faCogs,
  faUserPlus, faAddressBook, faThLarge, faPlusCircle, faPaintBrush, faArrowCircleLeft, faPiggyBank,
  faIdCard, faGraduationCap, faEnvelopeOpenText, faUserTie, faQuestion, faHashtag
);

export default {
  name: 'Sidebar',
  computed: {
    root() {
      return this.$router.options.routes.filter(route => route.path === '/').pop();
    },
    routes() {
      const flatten = routes => {
        return routes.children.reduce((accumulated, current) => {
          if (current.name && current.meta) {
            accumulated[current.name] = current.meta;
          }

          if (current.children) {
            accumulated = Object.assign({}, accumulated, flatten(current));
          }

          return accumulated;
        }, {});
      };

      const routes = flatten(this.root);
      Object.keys(routes).map(name => {
        const route = Object.assign({}, routes[name]);

        if (!route.navigation || !route.navigation.menu) {
          return;
        }

        let menu = route.navigation.menu.filter(item => get(routes, `${item}.navigation.link`)).map(item => ({
          name: item,
          ...get(routes, `${item}.navigation.link`)
        }));

        if (menu.length > 0) {
          route.navigation.menu = menu;
        }

        routes[name] = route;
      });

      return routes;
    },
    navigation() {
      const route = this.routes[this.$route.name];

      if (!route.navigation || !route.navigation.menu) {
        return this.getParentNavigation(get(route, 'navigation.parent'));
      }

      let menu = route.navigation.menu;

      menu = menu.map(item => {
        const parent = this.findParentByName(this.root, item.name);
        if (!parent || !parent.link) {
          return item;
        }
        item.icon = parent.link.icon;
        item.label = parent.link.label;
        return item;
      });

      if (menu) {
        route.navigation.menu = menu;
      }

      return route.navigation;
    },
  },
  methods: {
    getParentNavigation(parent) {
      if (parent) {
        return this.getParentNavigationByName(parent);
      }

      return this.getParentNavigationByCurrentRoute();
    },
    getParentNavigationByName(name) {
      const route = this.routes[name];

      if (!route.navigation || !route.navigation.menu) {
        return null;
      }

      return route.navigation;
    },
    getParentNavigationByCurrentRoute() {
      const parent = this.findParentByName(this.root, this.$route.name);

      if (!parent.menu) {
        return null;
      }

      let menu = parent.menu.filter(item => get(this.routes, `${item}.navigation.link`)).map(item => {
        return {
          name: item,
          ...get(this.routes, `${item}.navigation.link`),
        };
      });

      if (menu.length > 0) {
        parent.menu = menu;
      }

      return parent;
    },
    findParentByName(routes, name) {
      return routes.children.reduce((accumulated, current) => {
        const navigation = get(current, 'meta.navigation');
        if (current.children && navigation) {
          if (current.children.some(child => child.name === name)) {
            accumulated = Object.assign({}, navigation);
          }

          accumulated = Object.assign({}, accumulated, this.findParentByName(current, name));
        }

        return accumulated;
      }, {});
    },
  },
};
</script>
<template>
  <aside class="d-flex position-fixed flex-column min-vh-100">
    <div class="logo-container text-center d-flex justify-content-center align-items-center">
      <h1>Ineo</h1>
    </div>
    <nav :class="{'open-sub-nav': navigation}">
      <div class="main-nav">
        <ul>
          <li>
            <router-link :to="{ name: 'dashboard' }" exact>
              <font-awesome-icon icon="desktop" />
              <span>Dashboard</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'courses-listing' }">
              <font-awesome-icon icon="graduation-cap" />
              <span>Courses</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'codes-listing' }">
              <font-awesome-icon icon="id-card" />
              <span>Codes</span>
            </router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'invitations-listing' }">
              <font-awesome-icon icon="envelope-open-text" />
              <span>Invitations</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'users-listing' }">
              <font-awesome-icon icon="users" />
              <span>Users</span>
            </router-link>
          </li> -->
          <li>
            <router-link :to="{ name: 'companies-listing' }">
              <font-awesome-icon icon="building" />
              <span>Companies</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'administrators-listing' }">
              <font-awesome-icon icon="user-tie" />
              <span>Administrators</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'exams-listing' }">
              <font-awesome-icon icon="question" />
              <span>Exams</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'tags-listing' }">
              <font-awesome-icon icon="hashtag" />
              <span>Tags</span>
            </router-link>
          </li>
        </ul>
      </div>
      <transition name="slide-fade">
        <div class="sub-nav" v-if="navigation">
          <ul class="sub-nav-back" v-if="navigation.back">
            <li>
              <router-link :to="{ name: navigation.back.name }" exact>
                <font-awesome-icon icon="arrow-circle-left" />
                {{ navigation.back.label }}
              </router-link>
            </li>
          </ul>
          <span v-if="navigation.title">{{ navigation.title }}</span>
          <ul class="flex-1">
            <li v-for="(item, index) in navigation.menu" :key="index">
              <router-link :to="{ name: item.name}" exact>
                <font-awesome-icon :icon="item.icon" />
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </transition>
    </nav>
  </aside>
</template>
